"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetSize = void 0;
var WidgetSize;
(function (WidgetSize) {
    WidgetSize[WidgetSize["Fill"] = 0] = "Fill";
    WidgetSize[WidgetSize["Normal"] = 1] = "Normal";
})(WidgetSize = exports.WidgetSize || (exports.WidgetSize = {}));
//# sourceMappingURL=IHomePanelWidget.js.map